import { ISearchGroup, IUsersFound } from '@/api/users'

export const isUsersFound = (contact: IUsersFound | ISearchGroup): contact is IUsersFound =>
  !!(contact as IUsersFound).jid

export const isSearchGroup = (contact: IUsersFound | ISearchGroup): contact is ISearchGroup =>
  !!(contact as ISearchGroup).uid
